module.exports = __webpack_public_path__ + "static/media/ab_gurung.d2a5c517.jpg";